// Copyright (c) 2015, YangtzeSoft Technologies. and Contributors
// License: GNU General Public License v3. See license.txt

if (!window.yangtzeerp) window.yangtzeerp = {};

yangtzeerp.subscribe_to_newsletter = function (opts, btn) {
	return yangtze.call({
		type: "POST",
		method: "yangtze.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { email: opts.email },
		callback: opts.callback,
	});
};
